import Backbone from 'backbone';

const LiveAssetModel = Backbone.Model.extend({
    urlRoot: '/api/rest/facade/video/clip',
    idAttribute: 'id',
    defaults: {
        video: {
            title: 'zsomething',
            alt: 'someAlt',
            original: 'true',
            updatedBy: 'Sinclair Digital',
            metadata: '',
            type: 'Video',
            caption: '',
            created: null,
            drm: '0',
            version: '1',
            attributes: [],
            thumbUrl: null,
            url: 'test',
        },
        tags: [],
        originalExternalId: null,
        inpoint: null,
        outpoint: null,
    },
    blacklist: ['siteid'],
    parse(data) {
        return data.data[0];
    },
    initialize: function initialize() {
        this.type = 'newscast';
    },
});
export default LiveAssetModel;
